'use client'

import dynamic from 'next/dynamic'
import { HeroBackground, Spotlight } from 'design-studio'

const ThreeHero = dynamic(
  () =>
    import('@/components/three/three-sculpture-hero').then((mod) => ({
      default: mod.ThreeSculptureHero,
    })),
  { ssr: false },
)

export function HomeBackground({ mountCanvas }: { mountCanvas: boolean }) {
  return (
    <HeroBackground className="h-[min(100vh,1600px)]">
      <div className="fixed z-[-1] h-full w-full bg-zinc-100 dark:bg-slate-900" />
      {mountCanvas && <ThreeHero />}
      {/* <Spotlight
        color="from-blue-950/90"
        className="fixed -top-224 -left-120 z-0 size-512"
      /> */}
      <Spotlight
        color="from-teal-600/20"
        className="-right-200 -bottom-250 z-0 hidden size-512"
      />
    </HeroBackground>
  )
}
